import { render, staticRenderFns } from "./USInfo.vue?vue&type=template&id=0cedb930&scoped=true"
import script from "./USInfo.vue?vue&type=script&lang=js"
export * from "./USInfo.vue?vue&type=script&lang=js"
import style0 from "./USInfo.vue?vue&type=style&index=0&id=0cedb930&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cedb930",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cedb930')) {
      api.createRecord('0cedb930', component.options)
    } else {
      api.reload('0cedb930', component.options)
    }
    module.hot.accept("./USInfo.vue?vue&type=template&id=0cedb930&scoped=true", function () {
      api.rerender('0cedb930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/IdentityKYC/components/USInfo.vue"
export default component.exports